import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [roleLoaded, setRoleLoaded] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Mtumiaji anawekwa MARA MOJA. Zamani alikuwa anawekwa baada ya
        // kusoma 'users' — kusoma kukishindikana, App ilibaki ikidhani
        // hajaingia wala hajatoka, na hakuweza kufika popote.
        setCurrentUser(user);
        try {
          const docSnap = await getDoc(doc(db, 'users', user.uid));
          setUserRole(docSnap.exists() ? (docSnap.data().role || null) : null);
        } catch (err) {
          console.error('Haikuwezekana kusoma nafasi ya mtumiaji:', err);
          setUserRole(null);
        } finally {
          setRoleLoaded(true);
          setLoading(false);
        }
      } else {
        setCurrentUser(null);
        setUserRole(null);
        setRoleLoaded(true);
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const value = { currentUser, userRole, loading, roleLoaded };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}